import { Transforms, Editor, Text, Range, Node, Element} from 'slate'
import { ElementWithType } from '../../../../../../utils/types'
import { isInlineElement } from '../../../utils/queries'

import { LIST_TYPES } from '../../../elements/Element/list/utils'


export const toggleBlock = (editor, format) => {
  let isActive = isBlockActive(editor, format)
  const isList = LIST_TYPES.includes(format)

  Editor.withoutNormalizing(editor, () => {
    Transforms.unwrapNodes(editor, {
      match: (n: any) => {
        return LIST_TYPES.includes(n.type)
      },
      split: true,
      mode: 'all',
    })

    if(editor.rteVersion >= 1){ // Updated structure

      Transforms.unwrapNodes(editor, {
        match: (n: any) => {
          if(Text.isText(n)) return false
          const child = n.children[0]
          return child.type === "fragment" && n.type === "li"
        },
        split: true,
        mode: 'all',
      })
    }

  })
  if (isActive && isList) {
    isActive = false
  }

  let type: string;
  if (isActive) {
    type = 'p'
  } else if (isList) {
    type = 'li'
  } 
  else {
    type = format
  }
  if(type !== 'code'){
    Transforms.setNodes(editor, {
      type: type,
    } as Partial<ElementWithType>)
  }

  if (!isActive) {
    if (format === 'code' && Range.isExpanded(editor.selection)) {

      if (!editor.selection) return

      const { anchor, focus } = editor.selection

      const isPartialSelection = (!Editor.isStart(editor, anchor, anchor.path) && !Editor.isEnd(editor, anchor, anchor.path)) || 
                                 (!Editor.isStart(editor, focus, focus.path) && !Editor.isEnd(editor, focus, focus.path))
      
      let text
      let preservedIndentLevel = null
      
      if (isPartialSelection) {
       
        const fragment = Editor.fragment(editor, editor.selection)
        text = fragment.map((node) => Node.string(node)).join('\n').trimStart().trimEnd()
      } else {
        const blockElements = []
        for (const [node, path] of Editor.nodes(editor, {
          at: editor.selection,
          match: (n: any) => !Text.isText(n) && !isInlineElement(n),
          mode: 'lowest'
        })) {
          const elementNode = node as ElementWithType
          if (preservedIndentLevel === null && elementNode.attrs?.['data-indent-level'] !== undefined) {
            preservedIndentLevel = elementNode.attrs['data-indent-level']
          }
      
          const textNodes = []
          for (const [textNode] of Editor.nodes(editor, {
            at: path,
            match: Text.isText,
            mode: 'lowest'
          })) {
            textNodes.push(textNode.text)
          }
   
          const blockText = textNodes.join('')
          blockElements.push(blockText)
        }
        
        text = blockElements.join('\n')
      }

      Transforms.delete(editor, { at: editor.selection })
      const codeAttrs: any = {
        language: 'html',
        ...editor.children[0].attrs
      }
      if (preservedIndentLevel !== null) {
        codeAttrs['data-indent-level'] = preservedIndentLevel
      }
      Transforms.insertNodes(editor, {
        type: 'code',
        attrs: codeAttrs,
        children: [{ text: text }]
      } as ElementWithType)
 
    }
    else {
      const nodesToUpdate: Array<{ path: any, indentLevel: number | undefined }> = []
      
      for (const [node, path] of Editor.nodes(editor, {
        at: editor.selection,
        match: (n: any) => !Text.isText(n) && !isInlineElement(n),
        mode: 'lowest'
      })) {
        const elementNode = node as ElementWithType
        const indentLevel = elementNode.attrs?.['data-indent-level']
        nodesToUpdate.push({ path, indentLevel })
      }
      
      for (const { path, indentLevel } of nodesToUpdate) {
        const preservedAttrs: any = {}
        if (indentLevel !== undefined) {
          preservedAttrs['data-indent-level'] = indentLevel
        }
        
        Transforms.setNodes(editor, {
          type: type,
          attrs: preservedAttrs
        } as Partial<ElementWithType>, { at: path })
      }
    }

  }
  if (!isActive && format === 'check-list') {
    Transforms.setNodes(editor, { checked: false } as Partial<ElementWithType>)
  }
  if (!isActive && isList) {
    const block = { type: format, children: [] }
    Transforms.wrapNodes(editor, block)
  }
}

export const isBlockActive = (editor, format) => {
  const [match] = Editor.nodes(editor, {
    match: (n: ElementWithType) => n.type === format,
  })
  return !!match
}

export const toggleMark = (editor, format) => {
  const isActive = isMarkActive(editor, format)
  isActive ? Editor.removeMark(editor, format) : Editor.addMark(editor, format, true)
}

export const isMarkActive = (editor, format) => {
  const marks = Editor.marks(editor)
  return marks ? marks[format] === true : false
}
